import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    width: "100%",
    marginBottom: 36,
    paddingBottom: 18,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
  eyebrow: {
    color: "#6cb7ff",
    fontSize: 10,
    fontWeight: 800,
    marginBottom: 8,
    letterSpacing: theme.direction === "rtl" ? 0 : ".14em",
    textTransform: theme.direction === "rtl" ? "none" : "uppercase",
  },
  title: {
    color: "#f8fafc",
    fontWeight: 850,
    fontSize: "clamp(2rem, 4vw, 3.2rem)",
    lineHeight: 1.2,
    letterSpacing: theme.direction === "rtl" ? 0 : "-.035em",
    textAlign: theme.direction === "rtl" ? "right" : "left",
    overflowWrap: "break-word",
  },
  line: {
    position: "relative",
    width: 108,
    height: 4,
    marginTop: 14,
    borderRadius: 999,
    background: "rgba(22,139,255,.13)",
    marginLeft: theme.direction === "rtl" ? "auto" : 0,
    marginRight: theme.direction === "rtl" ? 0 : "auto",
    overflow: "hidden",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      width: 42,
      left: theme.direction === "rtl" ? "auto" : 0,
      right: theme.direction === "rtl" ? 0 : "auto",
      borderRadius: 999,
      background: "linear-gradient(90deg,#168bff,#54b7ff)",
      boxShadow: "0 0 18px rgba(22,139,255,.38)",
    },
  },
}));

export default function Title({ title, eyebrow }) {
  const classes = useStyles();

  return (
    <header className={classes.root}>
      {eyebrow ? <div className={classes.eyebrow}>{eyebrow}</div> : null}
      <Typography component="h1" className={classes.title}>
        {title}
      </Typography>
      <div className={classes.line} />
    </header>
  );
}
